module.exports = __webpack_public_path__ + "../resources/img/ic_re_clear_day_solid.28d73568.svg";